"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeCache = exports.dataSelfHelper = void 0;
const lodash_1 = require("lodash");
/**
 * 1. The getCellValue process finds data that needs to be remedied
 * 2. Collect the data to be acquired into the helper for management.
 * 3. Timed batch remediation data in UI
 */
class DataSelfHelper {
    constructor() {
        this.dataMap = new Map();
    }
    clear() {
        this.dataMap.clear();
    }
    addRecord(dstId, recordId, fieldId) {
        const key = `${dstId}-${fieldId}`;
        if (!this.dataMap.has(key)) {
            this.dataMap.set(key, new Set([recordId]));
        }
        else {
            const dstRecordIdSet = this.dataMap.get(key);
            dstRecordIdSet === null || dstRecordIdSet === void 0 ? void 0 : dstRecordIdSet.add(recordId);
        }
    }
    // Confirm after the recovery data is successful
    confirm(key, recordIds) {
        const dstRecordIdSet = this.dataMap.get(key);
        if (dstRecordIdSet) {
            // During the remediation process, new records that need remediation may be added, and the difference is calculated.
            const restRecordIds = (0, lodash_1.difference)(Array.from(dstRecordIdSet), recordIds);
            if (restRecordIds.length) {
                this.dataMap.set(key, new Set(restRecordIds));
            }
            else {
                this.dataMap.delete(key);
            }
        }
    }
    get needHelper() {
        return this.dataMap.size > 0;
    }
}
// Implement self-rescue measures for data loss caused by dirty data. Ensure that the data can be displayed normally on the UI.
exports.dataSelfHelper = new DataSelfHelper();
// Map used to store the calculation cache
exports.computeCache = new Map();
//# sourceMappingURL=compute_cache_manager.js.map